<script>
    export let modal_show = false;
    export let modal_width = undefined;
    export let modal_padding = 20;

    let modal;

    function hanldeContainerClick(event) {
        if (modal && !modal.contains(event.target)) {
            modal_show = false;
        }
    }

</script>


{#if modal_show}
<div class='modal_container' on:click={hanldeContainerClick}>
    <div class='modal_body' style={`width: ${modal_width ? modal_width : 800}px; padding: ${modal_padding}px`} bind:this={modal}>
        <div class='modal_close_icon_container' on:click={() => { modal_show = false; }}>
            <i class='fas fa-close'></i>
        </div>
		<slot></slot>
	</div>
</div>
{/if}


<style>
    .modal_container {
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: #000000c9;
        top: 0px;
        left: 0px;
        z-index: 10;
    }
    .modal_body {
        width: 800px;
        margin-top: 50px;
        margin-left: auto;
        margin-right: auto;
        background: white;
        border-radius: 3px;
        position: relative;
    }
    .modal_close_icon_container {
        z-index: 10;
        display: inline-block;
        position: absolute;
        right: 15px;
        top: 6px;
        cursor: pointer;
        font-size: 25px;
    }

    @media (max-width: 800px) {
        .modal_body {
            width: 95%;
        }
    }
</style>